import { axios } from '@/utils/request'

export const productionInfo = () => {
  return axios.get('/api/web/biz/production/exist')
}
